<!--头部-->
<template>
  <div class="header" @click="closeDropdowns">
    <div class="header-top">
      <div class="header-top-content">
        <div class="header-top-left">
          <div class="logo">
            <img alt="智维驿" class="logo-image" src="/logo.png">
            <div class="logo-text"><h1>智维驿</h1><span>智能设备后市场服务数智化云平台</span></div>
          </div>
          <span>全国服务热线：{{ phone }}</span>
          <span>服务时间：7×24小时</span>
        </div>
        <div class="header-top-right">
<!--          <div class="city-select-options" v-show="optionShow">-->
<!--            <div class="city-select-option" v-for="i in cities" :key="i" @click="changeCity(i)">{{ i }}</div>-->
<!--          </div>-->
<!--          <div class="city-select" @click.stop="optionShow=true">-->
<!--            <div>{{ city }}</div>-->
<!--            <el-icon class="city-select-icon">-->
<!--              <Location/>-->
<!--            </el-icon>-->
<!--          </div>-->
          <!-- 未登录状态：显示登录按钮和灰色头像 -->
          <template v-if="!isLoggedIn">
            <div class="user-avatar-placeholder">
              <el-icon>
                <UserFilled/>
              </el-icon>
            </div>
            <button type="button" class="header-btn" @click="goToLogin">
              <span>登录</span>
            </button>
          </template>
          <!-- 已登录状态：显示用户头像和昵称 -->
          <template v-else>
            <div class="user-info-wrapper" @mouseenter="showUserMenu" @mouseleave="scheduleHideUserMenu">
              <div class="user-info" @click="goToProfile">
                <img v-if="userInfo.avatar" :src="userInfo.avatar" :alt="userInfo.nickname || '用户'" class="user-avatar">
                <div v-else class="user-avatar-placeholder">
                  <el-icon>
                    <UserFilled/>
                  </el-icon>
                </div>
                <span class="user-name">{{ userInfo.nickname || '用户' }}</span>
              </div>
              <div class="user-dropdown" v-show="isLoggedIn && userMenuVisible" @mouseenter="showUserMenu"
                   @mouseleave="scheduleHideUserMenu">
                <div class="user-dropdown-item" @click.stop="goToLeaseManagement">租赁管理</div>
                <div class="user-dropdown-item" @click.stop="goToWorkOrderManagement">工单管理</div>
                <div class="user-dropdown-item" @click.stop="goToAddressManagement">地址管理</div>
                <div class="user-dropdown-item" @click.stop="logout">退出登录</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="header-main">
      <div class="banner-ad" @click.stop="goToVideo">
        <!-- 光粒子 -->
        <div class="particle p1"></div>
        <div class="particle p2"></div>
        <div class="particle p3"></div>

        <!-- 左侧3D图标 -->
        <div class="icon-wrap">
          <div class="ring-outer"></div>
          <div class="ring-middle"></div>
          <div class="play-core">
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="11" fill="none"/>
              <path d="M9 8 L9 16 L16 12 Z" fill="#F06825"/>
            </svg>
          </div>
          <div class="orbital-particles"></div>
        </div>

        <!-- 中心文案 -->
        <div class="text-content">
          <h1 class="main-title">
            <span class="free-text">免费</span>
            提供制卡设备维修视频
          </h1>
          <p class="sub-title">覆盖金融设备、工业设备、新能源设备、机器人、无人机等各类智能设备的维修服务，并提供保养、维修、管理、租赁等服务。</p>
        </div>

        <!-- 右侧引力按钮 -->
        <button class="cta-button">
          <span>立即观看</span>
          <div class="wave-effect"></div>
          <div class="btn-particles"></div>
        </button>
      </div>
    </div>
    <div class="main-menu-bg">
      <div class="main-menu-content">
        <div class="main-menu-wrapper">
          <ul class="main-menu">
            <li v-for="item in menuItems" :key="item.id"
                :class="['main-menu-item', { 'main-menu-item-active': item.active }]"
                @click="handleMenuClick(item)">
              <span class="main-menu-title">{{ item.label }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {defineProps, inject, onMounted, ref, watch, watchEffect, computed, onUnmounted} from 'vue';
import apiClient from "@/components/plugins/axios";
import {useRouter, useRoute} from 'vue-router'
import {Location, UserFilled} from '@element-plus/icons-vue'

const router = useRouter()
const route = useRoute()
const phone = ref('4008768770')
const city = ref('上海')
const cities = ref(['北京', '上海', '广州', '深圳', '更多城市'])
const optionShow = ref(false)
const userMenuVisible = ref(false)
let userMenuHideTimer = null
const userInfo = ref({})
// 创建一个响应式的 token 引用，用于触发 watchEffect
const tokenRef = ref(localStorage.getItem('access_token'))

// 检查是否登录
const isLoggedIn = computed(function () {
  return !!tokenRef.value
})

// 获取用户信息
function getUserInfo() {
  try {
    const userInfoStr = localStorage.getItem('userInfo')
    if (userInfoStr) {
      userInfo.value = JSON.parse(userInfoStr)
    } else {
      userInfo.value = {}
    }
  } catch (error) {
    userInfo.value = {}
  }
}

// 监听 localStorage 变化（用于跨标签页同步）
function handleStorageChange(e) {
  if (e.key === 'access_token') {
    tokenRef.value = e.newValue
    getUserInfo()
  } else if (e.key === 'userInfo') {
    getUserInfo()
  }
}

// 监听自定义事件（用于同标签页内同步）
function handleAuthChange() {
  // 更新响应式的 token 引用，触发 watchEffect
  tokenRef.value = localStorage.getItem('access_token')
  // 延迟更新用户信息，确保 localStorage 已经更新完成
  setTimeout(() => {
    getUserInfo()
  }, 50)
}

onMounted(function () {
  getUserInfo()
  window.addEventListener('storage', handleStorageChange)
  // 监听自定义事件，用于同标签页内的登录/退出通知
  window.addEventListener('auth-change', handleAuthChange)
})

onUnmounted(function () {
  window.removeEventListener('storage', handleStorageChange)
  window.removeEventListener('auth-change', handleAuthChange)
  if (userMenuHideTimer) {
    clearTimeout(userMenuHideTimer)
    userMenuHideTimer = null
  }
})

// 监听登录状态变化，自动更新用户信息
watchEffect(function () {
  // 当 tokenRef 变化时，自动更新用户信息
  if (tokenRef.value) {
    getUserInfo()
  } else {
    userInfo.value = {}
  }
})

// 监听路由变化，更新用户信息（登录后跳转回来时）
watch(function () {
  return route.path
}, function () {
  getUserInfo()
}, {immediate: true})

const menuItems = ref([
  {id: 'home', label: '首页', path: '/', active: true},
  // {id: 'service', label: '全部服务', path: '/service', active: false},
  {id: 'repair', label: '一键报修', path: '/repair', active: false},
  {id: 'lease', label: '一键租赁', path: '/lease', active: false},
  {id: 'customerServiceView', label: '免费咨询', path: '/customerServiceView', active: false},
  {id: 'knowledge', label: '维修知识', path: '/knowledge', active: false},
  {id: 'technology', label: '前沿技术', path: '/technology', active: false},
  {id: 'cases', label: '客户案例', path: '/cases', active: false},
  {id: 'about', label: '关于我们', path: '/about', active: false},
  {id: 'download', label: '下载中心', path: '/download', active: false},
])

function changeCity(i) {
  if (i !== '更多城市') {
    city.value = i;
  } else {
    router.push({name: 'City'})
  }
}

function goToLogin() {
  router.push('/login')
}

function goToProfile() {
  router.push('/profile')
}

function goToLeaseManagement() {
  router.push('/leaseCenter')
}
function goToWorkOrderManagement() {
  router.push('/workOrder')
}
function goToAddressManagement() {
  router.push('/address')
}

function goToVideo() {
  router.push('/video')
}

function logout() {
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('userInfo')
  tokenRef.value = null
  userInfo.value = {}
  userMenuVisible.value = false
  // 触发自定义事件，通知其他组件更新
  window.dispatchEvent(new CustomEvent('auth-change'))
  router.push('/login')
}

function handleMenuClick(item) {
  // 更新所有菜单项的 active 状态
  menuItems.value.forEach(function (menuItem) {
    menuItem.active = menuItem.id === item.id
  })
  // 进行路由跳转
  router.push(item.path)
}

// 监听路由变化，自动更新菜单激活状态
watch(function () {
  return route.path
}, function (newPath) {
  menuItems.value.forEach(function (menuItem) {
    // 对于首页，需要精确匹配
    if (menuItem.path === '/') {
      menuItem.active = newPath === '/'
    } else {
      // 对于其他路由，使用 startsWith 匹配，支持子路由
      menuItem.active = newPath.startsWith(menuItem.path)
    }
  })
}, {immediate: true})

function closeDropdowns() {
  optionShow.value = false
  userMenuVisible.value = false
}

function showUserMenu() {
  // 只有在登录状态下才显示下拉菜单
  if (!isLoggedIn.value) {
    return
  }
  if (userMenuHideTimer) {
    clearTimeout(userMenuHideTimer)
    userMenuHideTimer = null
  }
  userMenuVisible.value = true
}

function scheduleHideUserMenu() {
  if (userMenuHideTimer) {
    clearTimeout(userMenuHideTimer)
  }
  userMenuHideTimer = setTimeout(() => {
    userMenuVisible.value = false
    userMenuHideTimer = null
  }, 120)
}
</script>
<style scoped>
.header {
  background: #fff;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.08);
  border-bottom: 1px solid #ffe0b2;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-top {
  background: #fff3e0;
  padding: 0 0; /* 原2px 0，改为0，减少高度 */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #b26a00;
  border-bottom: 1px solid #ffe0b2;
  letter-spacing: 0.5px;
  width: 100%;
}

.header-top-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100rem;
  margin: 0 auto;
  padding: 0 10rem;
  box-sizing: border-box;
}


.header-top-left {
  width: 50rem;
  display: flex;
  align-items: center;
}

.header-top-left span {
  font-size: 0.7rem;
  margin-right: 0.75rem;
  transition: background 0.2s;
  border-radius: 4px;
  padding: 0.125rem 0.25rem;
}

.header-top-right {
  width: 15rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
}

.city-select-options {
  color: #606266;
  position: absolute;
  top: 2rem;
  font-size: 0.8rem;
  width: 7rem;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 101;
  border-radius: 5px;
  padding: 0.25rem;
}

.city-select-option {
  border-radius: 5px;
  padding: 0 0.5rem;
  height: 1.7rem;
  line-height: 1.7rem;
}

.city-select-option:hover {
  background: rgba(230, 230, 230);
  cursor: pointer;
}

.city-select {
  font-size: 0.8rem;
  color: #606266;
  width: 7rem;
  height: 1.7rem;
  line-height: 1.7rem;
  border-radius: 12px;
  padding: 0 0.5rem;
  border: 1px solid #ffe0b2;
  background: #fff8e1;
  box-shadow: 0 1px 4px rgba(255, 152, 0, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.city-select:hover {
  border: 1px solid #4096ff;
}

.city-select-icon {
  color: rgb(255, 152, 0);
  font-size: 1rem;
}

.city-select-icon .el-icon {
  font-size: 1rem;
}

.header-btn {
  font-size: 0.7rem;
  padding: 0 0.5rem;
  color: #1677ff;
  border-radius: 12px;
  transition: background 0.2s;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.header-btn:hover {
  color: #69b1ff;
}

.header-btn svg {
  font-size: 0.875rem;
}

/* 用户信息样式 */
.user-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.user-info-wrapper {
  position: relative;
}

.user-dropdown {
  position: absolute;
  top: 2.1rem;
  right: 0;
  width: 7rem;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
  z-index: 200;
}

.user-dropdown-item {
  padding: 0.6rem 0.9rem;
  font-size: 0.8rem;
  color: #333;
  transition: background-color 0.2s, color 0.2s;
}

.user-dropdown-item:hover {
  cursor: pointer;
  background: #f5f7ff;
  color: #1677ff;
}

.user-avatar {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #e0e0e0;
}

.user-avatar-placeholder {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background-color: #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}

.user-avatar-placeholder .el-icon {
  font-size: 0.875rem;
}

.user-name {
  font-size: 0.75rem;
  color: #1677ff;
  font-weight: 500;
}


.header-main {
  padding: 2px 0 1px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 6rem;
  gap: 8px;
}

.banner-ad {
  width: 100%;
  height: 100%;
  /* 调整后的浅蓝色渐变背景 */
  background: linear-gradient(180deg, #1E3A8A 0%, #3B82F6 50%, #1E3A8A 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 120px;
  position: relative;
  overflow: hidden;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.1);
  cursor: pointer;
}

/* 背景网格（颜色调浅以匹配新背景） */
.banner-ad::before {
  content: '';
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-image:
      linear-gradient(90deg, #60A5FA 1px, transparent 1px),
      linear-gradient(180deg, #60A5FA 1px, transparent 1px);
  background-size: 80px 80px;
  opacity: 0.18; /* 略微提高透明度 */
  pointer-events: none;
}

/* 光粒子（调亮以形成更好对比） */
.particle {
  position: absolute;
  background: #FBBF24; /* 更亮的橙黄色 */
  border-radius: 50%;
  pointer-events: none;
  filter: blur(0.5px); /* 柔化边缘 */
}
.p1 { top: 40px; left: 300px; width: 4px; height: 4px; animation: sparkle 2s infinite; }
.p2 { top: 140px; right: 300px; width: 5px; height: 5px; animation: breathe 3s infinite; }
.p3 { top: 100px; left: 50%; width: 3px; height: 3px; animation: drift 5s infinite; }

/* 左侧3D图标（保持不变） */
.icon-wrap {
  position: relative;
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  filter: drop-shadow(0 6px 20px rgba(240,104,37,0.3));
}

.ring-outer {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid #F06825;
  border-radius: 50%;
  animation: rotateRing 5s linear infinite;
}

.ring-middle {
  position: absolute;
  top: 10px; left: 10px;
  width: 60px; height: 60px;
  border: 1px dashed #F06825;
  border-radius: 50%;
  animation: rotateRingReverse 8s linear infinite;
}

.play-core {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  animation: float 3s ease-in-out infinite;
}

.play-core svg {
  width: 44px; height: 44px;
  filter: drop-shadow(0 0 12px rgba(240,104,37,0.8));
}

.orbital-particles {
  position: absolute;
  width: 100%; height: 100%;
  animation: rotateRing 10s linear infinite;
}
.orbital-particles::before,
.orbital-particles::after,
.orbital-particles span {
  content: '';
  position: absolute;
  width: 5px; height: 5px;
  background: #F06825;
  border-radius: 50%;
  box-shadow: 0 0 8px #F06825;
}
.orbital-particles::before { top: 5px; left: 50%; }
.orbital-particles::after { bottom: 5px; left: 50%; }
.orbital-particles span { top: 50%; right: 5px; }

/* 中心文案 */
.text-content {

  flex-grow: 1;
  text-align: center;
  margin: 0 80px;
  z-index: 2;
}

.main-title {
  font-size: 2.7rem;
  font-weight: 900;
  color: #FFFFFF;
  letter-spacing: 1.5px;
  line-height: 1.2;
  margin-bottom: 12px;
  text-shadow: 0 4px 20px rgba(0,0,0,0.6);
}

.main-title .free-text {
  color: #F06825;
  display: inline-block;
  position: relative;
  animation: glow 2s ease-in-out infinite alternate;
}

.main-title .free-text::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, transparent, #F06825, transparent);
  border-radius: 2px;
  animation: underlineFlow 4s linear infinite;
}

.sub-title {
  font-size: 0.9rem;
  font-weight: 500;
  color: #BFDBFE; /* 副标题颜色调浅 */
  letter-spacing: 1px;
  opacity: 0;
  animation: fadeInUp 1s ease-out 0.8s forwards;
}

/* 右侧引力按钮 */
.cta-button {
  position: relative;
  background: linear-gradient(135deg, #F06825 0%, #FF8C42 100%);
  border: none;
  border-radius: 28px;
  padding: 18px 48px;
  font-size: 22px;
  font-weight: 700;
  color: #FFFFFF;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow:
      0 6px 24px rgba(240, 104, 37, 0.5),
      inset 0 2px 4px rgba(255,255,255,0.2);
  animation: magneticFloat 4s ease-in-out infinite;
  overflow: hidden;
}

.cta-button:hover {
  transform: scale(1.05) translateY(-4px);
  box-shadow:
      0 12px 40px rgba(240, 104, 37, 0.7),
      inset 0 2px 4px rgba(255,255,255,0.3);
}

.cta-button:active {
  transform: scale(0.98);
}

.wave-effect {
  position: absolute;
  top: 0; left: -100%;
  width: 100%; height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.35), transparent);
  transition: left 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.cta-button:hover .wave-effect {
  left: 100%;
}

.btn-particles {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  pointer-events: none;
}
.btn-particles::before,
.btn-particles::after {
  content: '';
  position: absolute;
  width: 4px; height: 4px;
  background: #F06825;
  border-radius: 50%;
  opacity: 0;
}
.btn-particles::before { top: 10px; right: 15px; }
.btn-particles::after { bottom: 10px; left: 15px; }
.cta-button:hover .btn-particles::before { animation: particleFly 1.2s ease-out; }
.cta-button:hover .btn-particles::after { animation: particleFly 1.2s ease-out 0.2s; }

/* 动画库 */
@keyframes rotateRing {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes rotateRingReverse {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(-360deg); }
}

@keyframes float {
  0%, 100% { transform: translate(-50%, -50%) translateY(0); }
  50% { transform: translate(-50%, -50%) translateY(-6px); }
}

@keyframes glow {
  0% { text-shadow: 0 0 20px rgba(240,104,37,0.7); }
  100% { text-shadow: 0 0 30px rgba(240,104,37,1); }
}

@keyframes underlineFlow {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

@keyframes fadeInUp {
  0% { opacity: 0; transform: translateY(20px); }
  100% { opacity: 1; transform: translateY(0); }
}

@keyframes magneticFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
}

@keyframes particleFly {
  0% { opacity: 1; transform: translate(0,0) scale(1); }
  100% { opacity: 0; transform: translate(20px,-20px) scale(0); }
}

@keyframes sparkle {
  0%, 100% { opacity: 0.3; transform: scale(0.8); }
  50% { opacity: 1; transform: scale(1.2); }
}

@keyframes breathe {
  0%, 100% { opacity: 0.4; transform: scale(1); }
  50% { opacity: 0.8; transform: scale(1.3); }
}

@keyframes drift {
  0% { transform: translateX(-50px) translateY(0); }
  50% { transform: translateX(0) translateY(-10px); }
  100% { transform: translateX(50px) translateY(0); }
}




.logo {
  display: flex;
  align-items: center;
  margin-right: 1rem
}

.logo-image {
  width: 2.25rem;
  height: 2.25rem;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
}

.logo-text {
  display: flex;
  align-items: flex-start;
}

.logo-text h1 {
  margin: 0;
  background: linear-gradient(90deg, #ff9800 60%, #ffb74d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 1.125rem;
  font-weight: 800;
  letter-spacing: 1.5px;
  line-height: 1.1;
}

.logo-text span {
  color: #bbb;
  font-size: 0.6875rem;
  font-weight: 400;
  margin-top: 0.125rem;
  letter-spacing: 0.5px;
}


.user-section span {
  font-size: 12px;
  font-weight: 400;
  margin-left: 2px;
  color: #aaa;
}

/* 菜单栏全屏背景 */
.main-menu-bg {
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  background: #fff7ed;
  border-top: 1px solid #ffe0b2;
  z-index: 1;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

/* 菜单栏内容定宽 - 保持与内容区一致 */
.main-menu-content {
  width: 70rem;
  margin: 0 auto;
  padding: 0 1rem;
  border-radius: 12px;
  background: transparent;
  display: flex;
  align-items: center;
  height: 2.5rem;
}


.main-menu-wrapper {
  flex: 1 1 0%;
  width: 0;
}

.main-menu {
  background: transparent;
  width: 100%;
  border-top: none;
  margin-top: 0;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  padding-right: 0;
  list-style: none;
  margin: 0;
  box-sizing: border-box;
}

.main-menu-item {
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  height: 2.5rem;
  line-height: 2.5rem;
  position: relative;
  transition: color 0.2s, border-bottom 0.2s;
  cursor: pointer;
}

.main-menu-item::after {
  content: '';
  display: block;
  position: absolute;
  left: 1rem;
  right: 1rem;
  bottom: 0;
  height: 3px;
  background: transparent;
  border-radius: 2px 2px 0 0;
  transition: all 0.2s;
}

.main-menu-item:hover::after {
  width: 60%;
  left: 20%;
  background: #1890ff;
}

.main-menu-item:hover {
  color: #ff9800;
  background: #fff3e0;
}

.main-menu-item-active {
  color: #ff9800;
  background: #fff3e0;
}

.main-menu-item-active::after {
  background: #ff9800 !important;
  width: 60% !important;
  left: 20% !important;
}

.main-menu-title {
  display: block;
}

</style>